<template>
  <div class="data-screen" v-loading="loading">
    <!-- 简化背景动效，只保留粒子 -->
    <div class="tech-background">
      <div class="particles">
        <div v-for="n in 120" :key="`p-${n}`" class="particle"></div>
      </div>

      <!-- 添加网格效果 -->
      <div class="grid">
        <div v-for="n in 20" :key="`h-${n}`" class="h-line"></div>
        <div v-for="n in 20" :key="`v-${n}`" class="v-line"></div>
      </div>
    </div>

    <dv-full-screen-container>
      <TopHeader
        :storeName="storeName"
        :currentDate="currentDate"
        :Weekday="Weekday"
        :weather="weather"
        @toggleFullScreen="toggleFullScreen"
      />
      <!-- 主体内容 -->
      <div class="main-content">
        <!-- 左侧面板 -->
        <div class="left-panel rank-panel">
          <dv-border-box-12 class="panel-item">
            <div class="yesterday-orders">
              <div class="chart-header">昨日订单数: {{ yesterdayTotal }}</div>
              <div class="box1-group">
                <div class="box1-title">堂食</div>
                <div class="box1-rows">
                  <dv-border-box-7 class="box1">
                    <div class="box1-num">
                      {{ yesterdayHallFood.breakfast }}
                    </div>
                    <div class="box1-label">早餐</div>
                  </dv-border-box-7>
                  <dv-border-box-7 class="box1">
                    <div class="box1-num" style="color: #75f95d">
                      {{ yesterdayHallFood.lunch }}
                    </div>
                    <div class="box1-label">午餐</div>
                  </dv-border-box-7>
                  <dv-border-box-7 class="box1">
                    <div class="box1-num" style="color: #ea3ef1">
                      {{ yesterdayHallFood.dinner }}
                    </div>
                    <div class="box1-label">晚餐</div>
                  </dv-border-box-7>
                </div>
              </div>
              <div class="box1-group">
                <div class="box1-title">外送</div>
                <div class="box1-rows">
                  <dv-border-box-7 class="box1">
                    <div class="box1-num">{{ yesterdayTakeout.breakfast }}</div>
                    <div class="box1-label">早餐</div>
                  </dv-border-box-7>
                  <dv-border-box-7 class="box1">
                    <div class="box1-num" style="color: #75f95d">
                      {{ yesterdayTakeout.lunch }}
                    </div>
                    <div class="box1-label">午餐</div>
                  </dv-border-box-7>
                  <dv-border-box-7 class="box1">
                    <div class="box1-num" style="color: #ea3ef1">
                      {{ yesterdayTakeout.dinner }}
                    </div>
                    <div class="box1-label">晚餐</div>
                  </dv-border-box-7>
                </div>
              </div>
            </div>
          </dv-border-box-12>

          <!-- 早餐销量排行 -->
          <dv-border-box-12 class="panel-item">
            <div class="chart-header">早餐销量排行</div>
            <dv-capsule-chart
              class="rank-chart"
              :config="breakfastRankOption"
            />
          </dv-border-box-12>

          <!-- 午餐晚餐销量排行 -->
          <dv-border-box-12 class="panel-item">
            <div class="chart-header">午餐、晚餐销量排行</div>
            <dv-capsule-chart
              class="rank-chart"
              :config="lunchDinnerRankOption"
            />
          </dv-border-box-12>
        </div>

        <!-- 中间面板 -->
        <div class="center-panel">
          <dv-border-box-9 class="order-panel" title="今日订单">
            <div class="order-header">
              <div class="title">
                堂食订单数: <span class="number">{{ liveOrderTotal }}</span>
              </div>
              <img class="today" src="../images/today.png" alt="" />
              <div class="title">
                外送订单数:
                <span class="number">{{ liveTakeoutOrderTotal }}</span>
              </div>
            </div>
            <div class="order-content">
              <div class="hall-food">
                <div class="type-icon">
                  <i class="iconfont icon-restaurant"></i>
                  堂食
                </div>
                <div class="meals">
                  <div class="meal-item">
                    <div class="count">{{ liveHallFood.breakfast }}</div>
                    <div class="label">早餐</div>
                  </div>
                  <div class="meal-item">
                    <div class="count" style="color: #75f95d">
                      {{ liveHallFood.lunch }}
                    </div>
                    <div class="label">午餐</div>
                  </div>
                  <div class="meal-item">
                    <div class="count" style="color: #ea3ef1">
                      {{ liveHallFood.dinner }}
                    </div>
                    <div class="label">晚餐</div>
                  </div>
                </div>
              </div>
              <div class="takeout">
                <div class="type-icon">
                  <i class="iconfont icon-takeout"></i>
                  外送
                </div>
                <div class="meals">
                  <div class="meal-item">
                    <div class="count">{{ liveTakeout.breakfast }}</div>
                    <div class="label">早餐</div>
                  </div>
                  <div class="meal-item">
                    <div class="count" style="color: #75f95d">
                      {{ liveTakeout.lunch }}
                    </div>
                    <div class="label">午餐</div>
                  </div>
                  <div class="meal-item">
                    <div class="count" style="color: #ea3ef1">
                      {{ liveTakeout.dinner }}
                    </div>
                    <div class="label">晚餐</div>
                  </div>
                </div>
              </div>
            </div>
          </dv-border-box-9>

          <!-- 消费频率模块 -->
          <dv-border-box-12 class="frequency-panel">
            <div class="chart-header">
              消费分析
              <el-tooltip 
                effect="dark" 
                placement="top"
                popper-class="frequency-tooltip"
              >
                <div slot="content">
                  <div class="tooltip-content">
                    <div class="tooltip-item">
                      <span class="label">每周6-7次：</span>
                      <span class="desc">几乎每天消费</span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">每周3-5次：</span>
                      <span class="desc">经常消费</span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">每周1-2次：</span>
                      <span class="desc">偶尔消费</span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">不定期：</span>
                      <span class="desc">临时消费</span>
                    </div>
                  </div>
                </div>
                <i class="el-icon-question help-icon"></i>
              </el-tooltip>
            </div>
            <div class="panel-content">
              <!-- 消费频率图表 -->
              <div class="chart-section">
                <dv-capsule-chart
                  class="frequency-chart"
                  :config="{
                    data: consumptionFrequencyData,
                    colors: ['#00c2ff', '#0066ff'],
                    unit: '人',
                    showValue: true,
                    textStyle: {
                      fontSize: 16,
                    },
                    barHeight: 30,
                    margin: [0, 50],
                    itemGap: 20,
                  }"
                />
              </div>

              <!-- 补贴信息模块 -->
              <div class="subsidy-info">
                <div class="subsidy-header">补贴信息</div>
                <div class="subsidy-details">
                  <div class="subsidy-item">
                    <span>今日补贴单数:</span>
                    <span>{{ Statistic.TodayCount }}</span>
                  </div>
                  <div class="subsidy-item">
                    <span>今日补贴金额:</span>
                    <span>{{ Statistic.TodayPrice }}</span>
                  </div>
                  <div class="subsidy-item">
                    <span>本月补贴单数:</span>
                    <span>{{ Statistic.MonthCount }}</span>
                  </div>
                  <div class="subsidy-item">
                    <span>本月补贴金额:</span>
                    <span>{{ Statistic.MonthPrice }}</span>
                  </div>
                </div>
              </div>
            </div>
          </dv-border-box-12>

          <!-- 食材溯源 -->
          <dv-border-box-9 class="trace-panel" title="食材溯源">
            <div class="chart-header">食材溯源</div>
            <dv-scroll-board
              :config="{
                header: ['物料', '供应商', '送货时间'],
                data: traceData,
                carousel: 'single',
                index: false,
                columnWidth: [160, 280],
                align: ['center', 'center', 'center'],
                rowNum: 5,
                headerBGC: 'rgba(0, 228, 255, 0.1)',
                oddRowBGC: 'rgba(0, 228, 255, 0.05)',
                evenRowBGC: 'transparent',
                waitTime: 2000,
                headerHeight: 35,
                rowHeight: 30,
              }"
              class="trace-board"
            />
          </dv-border-box-9>
        </div>

        <!-- 右侧面板 -->
        <div class="right-panel">
          <!-- 健康证轮播 -->
          <dv-border-box-12 class="health-cert-panel">
            <div class="chart-header">健康证信息</div>
            <div class="cert-carousel">
              <div
                class="cert-item"
                v-for="(cert, index) in healthCertData"
                :key="index + cert.Url"
                :style="{
                  transform: getTransform(index),
                  zIndex: getZIndex(index),
                  opacity: getOpacity(index),
                }"
              >
                <div class="cert-image">
                  <img :src="cert.Url" alt="健康证" />
                </div>
              </div>
            </div>
          </dv-border-box-12>

          <!-- 骑手送餐飞线图 -->
          <dv-border-box-12
            class="trace-panel delivery-height"
            title="骑手配送"
          >
            <div class="chart-header">骑手配送</div>
            <template v-if="deliveryData && deliveryData.length">
              <dv-scroll-board
                :config="{
                  header: ['用户', '餐别', '骑手', '状态'],
                  data: deliveryData,
                  carousel: 'single',
                  index: false,
                  columnWidth: [120, 80, 100],
                  align: ['center', 'center', 'center', 'center'],
                  rowNum: 7,
                  headerBGC: 'rgba(0, 228, 255, 0.1)',
                  oddRowBGC: 'rgba(0, 228, 255, 0.05)',
                  evenRowBGC: 'transparent',
                  waitTime: 2000,
                  headerHeight: 35,
                  rowHeight: 30,
                  headerFontWeight: 400,
                  headerColor: '#00e4ff',
                }"
                class="trace-board"
              />
            </template>
            <template v-else>
              <div class="empty-state">
                <i class="el-icon-takeaway-box"></i>
                <div class="empty-text">暂无配送订单</div>
              </div>
            </template>
          </dv-border-box-12>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import TopHeader from "@/components/topHeader.vue";
import TechBackground from "@/components/TechBackground.vue";
import axios from "axios";
import { getCashierDashboard } from "@/api/dashboard";

export default {
  name: "DataScreen",
  components: {
    TopHeader,
    TechBackground,
  },
  data() {
    return {
      loading: false,
      storeName: "",
      weather: {},
      currentDate: "",
      Weekday: "",
      yesterdayHallFood: {
        breakfast: 0,
        lunch: 0,
        dinner: 0,
      },
      yesterdayTakeout: {
        breakfast: 0,
        lunch: 0,
        dinner: 0,
      },
      liveHallFood: {
        breakfast: 0,
        lunch: 0,
        dinner: 0,
      },
      liveTakeout: {
        breakfast: 0,
        lunch: 0,
        dinner: 0,
      },
      breakfastAvgPrice: {
        under60: 0,
        age60to69: 0,
        above70: 0,
      },
      lunchDinnerAvgPrice: {
        under60: 0,
        age60to69: 0,
        above70: 0,
      },
      userStats: {
        age60to69: { male: 0, female: 0 },
        age70to79: { male: 0, female: 0 },
        age80plus: { male: 0, female: 0 },
      },
      consumptionFrequency: [],
      breakfastRankData: [],
      breakfastRankOption: {},
      lunchDinnerRankData: [],
      lunchDinnerRankOption: {},
      frequencyChartOption: {},
      takeoutTypes: [
        { key: "breakfast", label: "白领早餐" },
        { key: "lunch", label: "为老送餐" },
        { key: "dinner", label: "普惠早餐" },
        { key: "elderly", label: "普惠午餐" },
      ],
      mealTypeMap: {
        breakfast: "早餐",
        lunch: "午餐",
        dinner: "晚餐",
      },
      ageRangeMap: {
        under60: "60岁以下",
        age60to69: "60-69岁",
        above70: "70岁以上",
      },
      chartStyle: {
        width: "100%",
        height: "300px",
      },
      isFullscreen: false,
      traceData: [],
      healthCertData: [
        {
          Url: "https://api.shangbokangsc.com/uploads/20250210/10b9ae1728083e7de6ed07bad70fe94e.jpg",
        },
        {
          Url: "https://api.shangbokangsc.com/uploads/20250210/81a8d35ea68b5f23b25e2409a89e73a2.jpg",
        },
        {
          Url: "https://api.shangbokangsc.com/uploads/20250210/10b9ae1728083e7de6ed07bad70fe94e.jpg",
        },
      ],
      currentRotation: 0,
      carouselInterval: null,
      deliveryData: [],
      MaleUserCount60_69: 0,
      FeMaleUserCount60_69: 0,
      MaleUserCount70_79: 0,
      FeMaleUserCount70_79: 0,
      MaleUserCount80: 0,
      FeMaleUserCount80: 0,
      Statistic: {
        TodayCount: 0,
        TodayPrice: 0,
        MonthCount: 0,
        MonthPrice: 0,
      },
    };
  },
  computed: {
    yesterdayTotal() {
      return (
        this.yesterdayHallFood.breakfast +
        this.yesterdayHallFood.lunch +
        this.yesterdayHallFood.dinner +
        this.yesterdayTakeout.breakfast +
        this.yesterdayTakeout.lunch +
        this.yesterdayTakeout.dinner
      );
    },
    liveOrderTotal() {
      return (
        this.liveHallFood.breakfast +
        this.liveHallFood.lunch +
        this.liveHallFood.dinner
      );
    },
    liveTakeoutOrderTotal() {
      return (
        this.liveTakeout.breakfast +
        this.liveTakeout.lunch +
        this.liveTakeout.dinner
      );
    },
    totalUsers() {
      return (
        this.userStats.age60to69.male +
        this.userStats.age60to69.female +
        this.userStats.age70to79.male +
        this.userStats.age70to79.female +
        this.userStats.age80plus.male +
        this.userStats.age80plus.female
      );
    },
    ageGroups() {
      return [
        {
          range: "60-69岁",
          male: this.userStats.age60to69.male,
          female: this.userStats.age60to69.female,
        },
        {
          range: "70-79岁",
          male: this.userStats.age70to79.male,
          female: this.userStats.age70to79.female,
        },
        {
          range: "80岁以上",
          male: this.userStats.age80plus.male,
          female: this.userStats.age80plus.female,
        },
      ];
    },
    consumptionFrequencyData() {
      return this.consumptionFrequency.map((item) => ({
        name: `${item.Type}`,
        value: item.UserCount,
      }));
    },
    healthData() {
      return this.healthCertData.map((item) => ({
        name: item.name,
        value: 1,
      }));
    },
    userCounts() {
      return {
        "60-69": {
          male: this.MaleUserCount60_69 || 0,
          female: this.FeMaleUserCount60_69 || 0,
        },
        "70-79": {
          male: this.MaleUserCount70_79 || 0,
          female: this.FeMaleUserCount70_79 || 0,
        },
        "80+": {
          male: this.MaleUserCount80 || 0,
          female: this.FeMaleUserCount80 || 0,
        },
      };
    },
  },
  methods: {
    processData(data) {
      console.log(data, "datadatadatadata");
      
      // 获取URL参数，判断当前使用的是哪个接口
      const urlParams = new URLSearchParams(window.location.search);
      const isNewApi = urlParams.get("id") !== null; // 有id参数表示使用新接口
      
      // 处理基础信息
      // 检查URL参数中的storeName，如果存在且不为空则使用URL中的值
      const urlStoreName = urlParams.get("storeName");
      if (urlStoreName && urlStoreName.trim() !== '') {
        this.storeName = urlStoreName;
        console.log('使用URL中的storeName:', urlStoreName);
      } else {
        this.storeName = data.StoreName;
        console.log('使用接口返回的storeName:', data.StoreName);
      }
      
      this.weather = data.Weather;
      this.currentDate = data.Date;
      this.Weekday = data.Weekday;
      
      // 昨日堂食URL参数
      const yesterdayHallBreakfast = urlParams.get("yesterdayHallBreakfast");
      const yesterdayHallLunch = urlParams.get("yesterdayHallLunch");
      const yesterdayHallDinner = urlParams.get("yesterdayHallDinner");
      
      // 昨日外送URL参数
      const yesterdayTakeoutBreakfast = urlParams.get("yesterdayTakeoutBreakfast");
      const yesterdayTakeoutLunch = urlParams.get("yesterdayTakeoutLunch");
      const yesterdayTakeoutDinner = urlParams.get("yesterdayTakeoutDinner");
      
      // 今日堂食URL参数
      const todayHallBreakfast = urlParams.get("todayHallBreakfast");
      const todayHallLunch = urlParams.get("todayHallLunch");
      const todayHallDinner = urlParams.get("todayHallDinner");
      
      // 今日外送URL参数
      const todayTakeoutBreakfast = urlParams.get("todayTakeoutBreakfast");
      const todayTakeoutLunch = urlParams.get("todayTakeoutLunch");
      const todayTakeoutDinner = urlParams.get("todayTakeoutDinner");

      // 处理昨日堂食数据，优先使用URL参数
      this.yesterdayHallFood = {
        breakfast: yesterdayHallBreakfast !== null ? parseInt(yesterdayHallBreakfast) : data.YesterdayHallfoodOrderCount.BreakfastOrderCount,
        lunch: yesterdayHallLunch !== null ? parseInt(yesterdayHallLunch) : data.YesterdayHallfoodOrderCount.LunchOrderCount,
        dinner: yesterdayHallDinner !== null ? parseInt(yesterdayHallDinner) : data.YesterdayHallfoodOrderCount.DinnerOrderCount,
      };
      
      // 处理昨日外送数据，优先使用URL参数
      this.yesterdayTakeout = {
        breakfast: yesterdayTakeoutBreakfast !== null ? parseInt(yesterdayTakeoutBreakfast) : data.YesterdayTakeoutOrderCount.BreakfastOrderCount,
        lunch: yesterdayTakeoutLunch !== null ? parseInt(yesterdayTakeoutLunch) : data.YesterdayTakeoutOrderCount.LunchOrderCount,
        dinner: yesterdayTakeoutDinner !== null ? parseInt(yesterdayTakeoutDinner) : data.YesterdayTakeoutOrderCount.DinnerOrderCount,
      };
      
      // 处理今日堂食数据，优先使用URL参数
      this.liveHallFood = {
        breakfast: todayHallBreakfast !== null ? parseInt(todayHallBreakfast) : data.LiveHallfoodOrderCount.BreakfastOrderCount,
        lunch: todayHallLunch !== null ? parseInt(todayHallLunch) : data.LiveHallfoodOrderCount.LunchOrderCount,
        dinner: todayHallDinner !== null ? parseInt(todayHallDinner) : data.LiveHallfoodOrderCount.DinnerOrderCount,
      };
      
      // 处理今日外送数据，优先使用URL参数
      this.liveTakeout = {
        breakfast: todayTakeoutBreakfast !== null ? parseInt(todayTakeoutBreakfast) : data.LiveTakeoutOrderCount.BreakfastOrderCount,
        lunch: todayTakeoutLunch !== null ? parseInt(todayTakeoutLunch) : data.LiveTakeoutOrderCount.LunchOrderCount,
        dinner: todayTakeoutDinner !== null ? parseInt(todayTakeoutDinner) : data.LiveTakeoutOrderCount.DinnerOrderCount,
      };

      // 处理用户统计
      this.userStats = {
        age60to69: {
          male: data.MaleUserCount60_69,
          female: data.FeMaleUserCount60_69,
        },
        age70to79: {
          male: data.MaleUserCount70_79,
          female: data.FeMaleUserCount70_79,
        },
        age80plus: {
          male: data.MaleUserCount80,
          female: data.FeMaleUserCount80,
        },
      };

      // 处理平均价格数据（兼容字段缺失）
      this.breakfastAvgPrice = {
        under60: data.BreakfastAveragePrice_30Days?.AvgPrice_60 || 0,
        age60to69: data.BreakfastAveragePrice_30Days?.AvgPrice60_69 || 0,
        above70: data.BreakfastAveragePrice_30Days?.AvgPrice70_ || 0,
      };

      this.lunchDinnerAvgPrice = {
        under60: data.LunchDinnerAveragePrice_30Days?.AvgPrice_60 || 0,
        age60to69: data.LunchDinnerAveragePrice_30Days?.AvgPrice60_69 || 0,
        above70: data.LunchDinnerAveragePrice_30Days?.AvgPrice70_ || 0,
      };

      // 处理消费频率数据 - 新接口使用模拟数据，老接口优先使用后端数据
      if (isNewApi) {
        // 新接口：直接使用模拟数据（跟老接口保持一致的处理方式）
        console.log("新接口：使用模拟数据生成消费分析");
        // 延迟执行，确保其他数据先处理完毕
        this.$nextTick(() => {
          this.generateConsumptionFrequencyFromSubsidy();
        });
      } else {
        // 老接口：优先使用后端数据，否则生成模拟数据
        if (data.ConsumptionFrequencyPercenCounts && data.ConsumptionFrequencyPercenCounts.length > 0) {
          this.consumptionFrequency = data.ConsumptionFrequencyPercenCounts;
          console.log("老接口：使用后端返回的消费频率数据:", this.consumptionFrequency);
        } else {
          console.log("老接口：后端未返回消费频率数据，使用模拟数据");
          this.generateConsumptionFrequencyFromSubsidy();
        }
      }

      // 设置图表配置
      this.setChartOptions(data);

      // 处理健康证数据
      if (data.Health) {
        this.healthCertData = data.Health;
      }

      // 处理食材溯源数据
      if (data.TraceSource) {
        this.traceData = data.TraceSource.map((item) => [
          item.Materials,
          item.Supplier,
          item.CreateTime,
        ]);
      }

      // 处理配送数据
      if (data.Delivery && data.Delivery.length) {
        this.deliveryData = data.Delivery.map((item) => [
          item.username,
          item.type,
          item.rider,
          item.status,
        ]);
      } else {
        this.deliveryData = [];
      }

      // 添加用户数量数据处理（兼容字段缺失）
      this.MaleUserCount60_69 = data.MaleUserCount60_69 || 0;
      this.FeMaleUserCount60_69 = data.FeMaleUserCount60_69 || 0;
      this.MaleUserCount70_79 = data.MaleUserCount70_79 || 0;
      this.FeMaleUserCount70_79 = data.FeMaleUserCount70_79 || 0;
      this.MaleUserCount80 = data.MaleUserCount80 || 0;
      this.FeMaleUserCount80 = data.FeMaleUserCount80 || 0;

      // 处理补贴数据（在订单数据处理之后）
      this.processSubsidyData(data);
    },
    setChartOptions(data) {
      // 检查URL参数，判断是否存在销量排行相关字段
      const urlParams = new URLSearchParams(window.location.search);
      const breakfastRankFromUrl = urlParams.get('BreakFastFoodSaleOrder');
      const lunchDinnerRankFromUrl = urlParams.get('LunchDinnerFoodSaleOrder');
      
      // 处理早餐销量排行数据
      let breakfastData = data.BreakFastFoodSaleOrder || [];
      // 当URL中有BreakFastFoodSaleOrder参数且不为空时，使用模拟数据
      if (breakfastRankFromUrl && breakfastRankFromUrl.trim() !== '') {
        // 使用模拟数据
        breakfastData = [
          { Type: "早餐", FoodName: "菜包", OrderCount: 2695 },
          { Type: "早餐", FoodName: "茶叶蛋", OrderCount: 1997 },
          { Type: "早餐", FoodName: "鲜肉大包", OrderCount: 1885 },
          { Type: "早餐", FoodName: "甜豆浆", OrderCount: 1578 },
          { Type: "早餐", FoodName: "油条", OrderCount: 1303 },
          { Type: "早餐", FoodName: "粢饭糕", OrderCount: 993 },
          { Type: "早餐", FoodName: "鲜肉锅贴（4只）", OrderCount: 760 },
          { Type: "早餐", FoodName: "花卷\/刀切", OrderCount: 697 },
          { Type: "早餐", FoodName: "差价", OrderCount: 597 },
          { Type: "早餐", FoodName: "白粥", OrderCount: 593 }
        ];
      }
      
      this.breakfastRankData = breakfastData.map((item) => ({
        name: item.FoodName,
        value: item.OrderCount,
      }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 10);

      this.breakfastRankOption = {
        data: this.breakfastRankData,
        colors: ['#00c2ff', '#0066ff'],
        unit: '份',
        showValue: true,
        textStyle: { fontSize: 16 },
        barHeight: 30,
        margin: [0, 50],
        itemGap: 20,
      }

      // 处理午餐晚餐销量排行数据
      let lunchDinnerData = data.LunchDinnerFoodSaleOrder || [];
      // 当URL中有LunchDinnerFoodSaleOrder参数且不为空时，使用模拟数据
      if (lunchDinnerRankFromUrl && lunchDinnerRankFromUrl.trim() !== '') {
        // 使用模拟数据
        lunchDinnerData = [
          { Type: "午餐晚餐", FoodName: "鹌鹑蛋红烧肉", OrderCount: 633 },
          { Type: "午餐晚餐", FoodName: "马蹄肉圆", OrderCount: 572 },
          { Type: "午餐晚餐", FoodName: "马蹄肉圆特价", OrderCount: 555 },
          { Type: "午餐晚餐", FoodName: "芹菜香干肉丝", OrderCount: 530 },
          { Type: "午餐晚餐", FoodName: "韭菜银牙", OrderCount: 472 },
          { Type: "午餐晚餐", FoodName: "海带丝", OrderCount: 364 },
          { Type: "午餐晚餐", FoodName: "黄豆芽油豆腐", OrderCount: 346 },
          { Type: "午餐晚餐", FoodName: "三鲜鱼面筋", OrderCount: 345 },
          { Type: "午餐晚餐", FoodName: "毛豆鸡块", OrderCount: 325 },
          { Type: "午餐晚餐", FoodName: "糟留鱼片", OrderCount: 322 },
          { Type: "午餐晚餐", FoodName: "鱼香茄子", OrderCount: 311 },
          { Type: "午餐晚餐", FoodName: "冬瓜毛豆", OrderCount: 309 }
        ];
      }
      
      this.lunchDinnerRankData = lunchDinnerData.map((item) => ({
        name: item.FoodName,
        value: item.OrderCount,
      }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 10);

      this.lunchDinnerRankOption = {
        data: this.lunchDinnerRankData,
        colors: ['#00c2ff', '#0066ff'],
        unit: '份',
        showValue: true,
        textStyle: { fontSize: 16 },
        barHeight: 30,
        margin: [0, 50],
        itemGap: 20,
      }

      // 消费频率图表配置 - 注释掉，现在使用模拟数据
      // this.frequencyChartOption = { ... }
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        this.isFullscreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.isFullscreen = false;
        }
      }
    },
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        this.currentRotation =
          (this.currentRotation + 1) % this.healthCertData.length;
      }, 5000);
    },
    getTransform(index) {
      const diff =
        (index - this.currentRotation + this.healthCertData.length) %
        this.healthCertData.length;
      const centerIndex = Math.floor(this.healthCertData.length / 2);

      if (diff === centerIndex) {
        return "translate(-50%, -50%) scale(1)";
      } else if (diff < centerIndex) {
        return "translate(-85%, -50%) scale(0.9)";
      } else {
        return "translate(-15%, -50%) scale(0.9)";
      }
    },
    getZIndex(index) {
      const diff =
        (index - this.currentRotation + this.healthCertData.length) %
        this.healthCertData.length;
      const centerIndex = Math.floor(this.healthCertData.length / 2);
      return diff === centerIndex ? 3 : 1;
    },
    getOpacity(index) {
      const diff =
        (index - this.currentRotation + this.healthCertData.length) %
        this.healthCertData.length;
      const centerIndex = Math.floor(this.healthCertData.length / 2);
      return diff === centerIndex ? 1 : 0.8;
    },
    async fetchDashboard() {
      try {
        this.loading = true;
        const urlParams = new URLSearchParams(window.location.search);
        const store_id = urlParams.get("store_id");
        const cashierId = urlParams.get("id");
        const type = urlParams.get("type");

        if (!store_id) {
          console.error("缺少必要的URL参数: store_id");
          return;
        }

        let apiResp;

        // 判断使用哪个接口
        if (cashierId) {
          // 有 id 参数，使用新接口
          console.log("使用新接口 - 带有id参数:", cashierId);
          apiResp = await getCashierDashboard({ store_id, id: cashierId });
        } else if (type === "2") {
          // 有 type=2 参数，使用老接口
          console.log("使用老接口 - 带有type=2参数");
          await this.getStoreDetail();
          return; // getStoreDetail 处理完毕直接返回
        } else {
          // 默认使用新接口
          console.log("使用新接口 - 默认情况");
          apiResp = await getCashierDashboard({ store_id });
        }

        // 兼容大小写字段名
        const code = apiResp.code != null ? apiResp.code : apiResp.Code;
        const message = apiResp.message || apiResp.Message;
        const data = apiResp.data || apiResp.Data || apiResp;

        if (code && Number(code) !== 200) {
          console.error("接口返回错误:", message || code);
          return;
        }

        this.processData(data);
      } catch (error) {
        console.error("获取大屏数据失败:", error);
      } finally {
        this.loading = false;
      }
    },
    async getStoreDetail() {
      try {
        this.loading = true;
        const urlParams = new URLSearchParams(window.location.search);
        const store_id = urlParams.get("store_id");
        const type = urlParams.get("type");

        if (!store_id || !type) {
          console.error("缺少必要的URL参数");
          return;
        }

        const response = await axios.get(
          `https://api.shangbokangsc.com/api/common/storeDetail`,
          {
            params: {
              store_id,
              type,
            },
          }
        );
        
        if (response.data && response.data.code === 200) {
          this.processData(response.data.data);
        } else {
          console.error("老接口返回错误:", response.data);
        }
      } catch (error) {
        console.error("获取老接口数据失败:", error);
      } finally {
        this.loading = false;
      }
    },
    // 新增方法：根据补贴信息生成消费分析数据
    generateConsumptionFrequencyFromSubsidy() {
      const { TodayCount, MonthCount, TodayPrice, MonthPrice } = this.Statistic;
      
      // 基于今日订单总数和补贴数据计算合理的用户分布
      const todayTotalOrders = this.liveOrderTotal + this.liveTakeoutOrderTotal;
      const avgOrdersPerUser = 1.3; // 假设平均每个用户每天1.3单
      const estimatedDailyUsers = Math.round(todayTotalOrders / avgOrdersPerUser);
      
      // 基于补贴比例调整总用户基数
      const subsidyRate = TodayCount / Math.max(todayTotalOrders, 1); // 补贴订单占比
      const totalActiveUsers = Math.round(estimatedDailyUsers * (1 + subsidyRate * 0.5)); // 适当增加用户基数
      
      // 更合理的用户分布比例
      const highFrequencyUsers = Math.round(totalActiveUsers * 0.15); // 高频用户15%
      const mediumFrequencyUsers = Math.round(totalActiveUsers * 0.35); // 中频用户35%
      const lowFrequencyUsers = Math.round(totalActiveUsers * 0.30); // 低频用户30%
      const occasionalUsers = Math.round(totalActiveUsers * 0.20); // 偶尔消费用户20%
      
      // 生成模拟的消费频率数据
      this.consumptionFrequency = [
        {
          Type: "每周6-7次",
          UserCount: highFrequencyUsers
        },
        {
          Type: "每周3-5次", 
          UserCount: mediumFrequencyUsers
        },
        {
          Type: "每周1-2次",
          UserCount: lowFrequencyUsers
        },
        {
          Type: "不定期",
          UserCount: occasionalUsers
        }
      ];
      
      console.log("模拟的消费分析数据:", this.consumptionFrequency);
      console.log("今日订单总数:", todayTotalOrders, "估算用户数:", totalActiveUsers);
    },
    // 处理补贴数据的方法
    processSubsidyData(data) {
      // 检查URL参数，判断是否要使用模拟补贴数据
      const urlParams = new URLSearchParams(window.location.search);
      const statisticFromUrl = urlParams.get('Statistic');
      
      console.log('processSubsidyData 开始执行, URL中的Statistic参数:', statisticFromUrl);
      console.log('原始数据:', data.Statistic);
      
      // 当URL中有Statistic参数且不为空时，使用模拟数据
      if (statisticFromUrl && statisticFromUrl.trim() !== '') {
        console.log('URL中有Statistic参数且不为空，使用模拟数据');
        
        // 计算今日总订单数（这时订单数据已经处理完毕）
        const todayHallTotal = this.liveHallFood.breakfast + this.liveHallFood.lunch + this.liveHallFood.dinner;
        const todayTakeoutTotal = this.liveTakeout.breakfast + this.liveTakeout.lunch + this.liveTakeout.dinner;
        const todayTotalOrders = todayHallTotal + todayTakeoutTotal;
        
        // 如果今日订单数为0，使用一个基础值
        const baseOrderCount = Math.max(todayTotalOrders, 30); // 至少30单
        
        // 基于今日订单数生成合理的补贴数据
        // 假设补贴率约为30-50%
        const subsidyRate = Math.random() * 0.2 + 0.3; // 30%-50%
        const todaySubsidyCount = Math.round(baseOrderCount * subsidyRate);
        
        // 平均每单补贴金额在8-15元之间
        const avgSubsidyAmount = Math.random() * 7 + 8; // 8-15元
        const todaySubsidyPrice = (todaySubsidyCount * avgSubsidyAmount).toFixed(2);
        
        // 本月数据基于今日数据估算（当前日期的倍数）
        const currentDate = new Date();
        const daysInMonth = currentDate.getDate();
        const monthMultiplier = Math.max(daysInMonth + Math.random() * 5 - 2.5, 10); // 至少10倍
        
        const monthSubsidyCount = Math.round(todaySubsidyCount * monthMultiplier);
        const monthSubsidyPrice = (parseFloat(todaySubsidyPrice) * monthMultiplier).toFixed(2);
        
        this.Statistic = {
          TodayCount: todaySubsidyCount,
          TodayPrice: todaySubsidyPrice,
          MonthCount: monthSubsidyCount,
          MonthPrice: monthSubsidyPrice
        };
        
        console.log('生成补贴模拟数据:', this.Statistic);
        return;
      }
      
      // 否则使用原有逻辑
      console.log('URL中没有Statistic参数，使用原有逻辑');
      
      // 确保 Statistic 被正确赋值（兼容字段缺失）
      let statisticData = data.Statistic || {
        TodayCount: 0,
        TodayPrice: 0,
        MonthCount: 0,
        MonthPrice: 0
      };
      
      // 检查补贴数据是否都是0（包括字符串"0"和"0.00"）
      const todayCountIsZero = statisticData.TodayCount == 0;
      const todayPriceIsZero = statisticData.TodayPrice == 0 || statisticData.TodayPrice == "0.00";
      const monthCountIsZero = statisticData.MonthCount == 0;
      const monthPriceIsZero = statisticData.MonthPrice == 0 || statisticData.MonthPrice == "0.00";
      
      // 如果补贴数据都是0，生成模拟的合理数据
      if (todayCountIsZero && todayPriceIsZero && monthCountIsZero && monthPriceIsZero) {
        console.log('补贴数据都是0，开始生成模拟数据');
        
        // 计算今日总订单数（这时订单数据已经处理完毕）
        const todayHallTotal = this.liveHallFood.breakfast + this.liveHallFood.lunch + this.liveHallFood.dinner;
        const todayTakeoutTotal = this.liveTakeout.breakfast + this.liveTakeout.lunch + this.liveTakeout.dinner;
        const todayTotalOrders = todayHallTotal + todayTakeoutTotal;
        
        // 如果今日订单数为0，使用一个基础值
        const baseOrderCount = Math.max(todayTotalOrders, 30); // 至少30单
        
        // 基于今日订单数生成合理的补贴数据
        // 假设补贴率约为30-50%
        const subsidyRate = Math.random() * 0.2 + 0.3; // 30%-50%
        const todaySubsidyCount = Math.round(baseOrderCount * subsidyRate);
        
        // 平均每单补贴金额在8-15元之间
        const avgSubsidyAmount = Math.random() * 7 + 8; // 8-15元
        const todaySubsidyPrice = (todaySubsidyCount * avgSubsidyAmount).toFixed(2);
        
        // 本月数据基于今日数据估算（当前日期的倍数）
        const currentDate = new Date();
        const daysInMonth = currentDate.getDate();
        const monthMultiplier = Math.max(daysInMonth + Math.random() * 5 - 2.5, 10); // 至少10倍
        
        const monthSubsidyCount = Math.round(todaySubsidyCount * monthMultiplier);
        const monthSubsidyPrice = (parseFloat(todaySubsidyPrice) * monthMultiplier).toFixed(2);
        
        statisticData = {
          TodayCount: todaySubsidyCount,
          TodayPrice: todaySubsidyPrice,
          MonthCount: monthSubsidyCount,
          MonthPrice: monthSubsidyPrice
        };
        
        console.log('生成补贴模拟数据（零数据情况）:', statisticData);
      }
      
      this.Statistic = statisticData;
      console.log('最终设置的补贴数据:', this.Statistic);
    },
  },
  created() {
    this.fetchDashboard();
    setInterval(() => {
      this.fetchDashboard();
    }, 60000);
  },
  mounted() {
    this.startCarousel();
  },
  beforeDestroy() {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
  },
};
</script>

<style lang="scss" scoped>
.data-screen {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #000428, #004e92);

  // 确保其他内容在背景之上
  > *:not(.tech-background) {
    position: relative;
    z-index: 1;
  }

  width: 100vw;
  height: 100vh;
  background: #000b2a;
  color: #fff;
  overflow: hidden;
  .today {
    width: 50px;
  }
  .chart-header {
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    font-size: 24px;
    color: #00e4ff;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 16px;
      background: #00e4ff;
      border-radius: 2px;
    }
  }
  // 头部样式
  .header {
    height: 80px;
    background: linear-gradient(
      90deg,
      rgba(0, 11, 42, 0),
      rgba(0, 11, 42, 0.8),
      rgba(0, 11, 42, 0)
    );
    border-bottom: 1px solid rgba(0, 228, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 40px;
    position: relative;

    .store-name {
      font-size: 24px;
    }

    .title {
      font-size: 36px;
      font-weight: bold;
      background: linear-gradient(180deg, #ffffff 0%, #7cdeff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .date-weather {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 24px;
      .date {
        margin-right: 20px;
      }
    }

    .fullscreen-btn {
      cursor: pointer;
      color: #00e4ff;
      font-size: 24px;
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  // 主体内容布局
  .main-content {
    width: 100vw;
    height: calc(100% - 80px);
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .left-panel {
      width: 24%;
      height: 100%;
      display: flex;
      margin-right: 35px;
      flex-direction: column;
    }

    .center-panel {
      width: 38%;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .right-panel {
      width: 28%;
      margin-left: 50px;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  // 面板通用样式
  .panel-item {
    padding: 15px;
    position: relative;
    height: max-content;
    .chart-header {
      height: 40px;
      line-height: 40px;
      padding-left: 15px;
      font-size: 24px;
      color: #00e4ff;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background: #00e4ff;
        border-radius: 2px;
      }
    }
  }

  // 订单统计面板
  .order-summary {
    height: max-content;
    .yesterday-orders {
      height: 100%;

      .yesterday-total {
        height: 30px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
      }

      .order-types {
        display: flex;

        .type-group {
          flex: 1;
          padding: 0 10px;

          &:first-child {
            border-right: 1px solid rgba(0, 228, 255, 0.1);
          }

          .type-title {
            height: 24px;
            line-height: 24px;
            margin-bottom: 10px;
            color: #00e4ff;
          }

          .type-data {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .data-item {
              height: 32px;
              display: flex;
              align-items: center;
              padding: 0 10px;
              background: rgba(0, 228, 255, 0.05);
              border-radius: 4px;

              .num {
                color: #00e4ff;
                margin-right: 10px;
                font-size: 20px;
              }

              .label {
                color: rgba(255, 255, 255, 0.8);
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
  .box1-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    padding-left: 25px;
  }
  .box1-title {
    color: #4f9db7;
    font-size: 24px;
    text-align: center;
    margin-right: 20px;
  }
  .box1-rows {
    display: flex;
    flex: 1;
    justify-content: space-around;
    align-items: center;
  }
  .box1 {
    width: 68px;
    height: 68px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(0, 228, 255, 0.1);
    border-radius: 4px;
    .box1-num {
      font-size: 20px;
      color: #00e4ff;
      text-align: center;
      margin-top: 8px;
    }
    .box1-label {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
    }
  }

  .rank-panel {
    display: flex;
    flex-direction: column;
    .chart-header {
      height: 40px;
      flex-shrink: 0;
    }

    .rank-chart {
      flex: 1;
      min-height: 300px;
      padding: 10px;
      width: 100%;
    }
  }

  .live-orders {
    padding: 15px;

    .section-title {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;

      .title-text {
        font-size: 24px;
        color: #00e4ff;
      }

      :deep(.dv-digital-flop) {
        margin-left: 10px;
      }
    }

    .meal-stats {
      display: flex;
      justify-content: space-around;
      padding: 20px 0;

      .meal-item {
        width: 30%;

        .meal-box {
          height: 120px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: rgba(0, 228, 255, 0.1);
          border-radius: 8px;
          transition: all 0.3s;

          &:hover {
            transform: translateY(-5px);
            background: rgba(0, 228, 255, 0.2);
          }

          .meal-icon {
            font-size: 32px;
            color: #00e4ff;
            margin-bottom: 10px;
          }

          .meal-count {
            font-size: 28px;
            color: #00e4ff;
            font-weight: bold;
            margin-bottom: 5px;
          }

          .meal-label {
            font-size: 16px;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }
}

.tech-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;

  .particles {
    position: absolute;
    width: 100%;
    height: 100%;

    .particle {
      position: absolute;
      width: 4px;
      height: 4px;
      background: rgba(0, 183, 255, 0.7);
      border-radius: 50%;
      box-shadow: 0 0 15px rgba(0, 183, 255, 0.9);

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: inherit;
        animation: pulse 2s ease-out infinite;
      }

      @for $i from 1 through 120 {
        &:nth-child(#{$i}) {
          $randomSize: #{random(4) + 2}px;
          width: $randomSize;
          height: $randomSize;
          left: #{random(100)}vw;
          top: #{random(100)}vh;
          animation: moveParticle#{$i} #{15 + random(25)}s linear infinite,
            blink #{2 + random(3)}s ease-in-out infinite;
          animation-delay: #{-random(20)}s;

          @keyframes moveParticle#{$i} {
            0%,
            100% {
              transform: translate(0, 0);
            }
            25% {
              transform: translate(
                #{random(600) - 300}px,
                #{random(600) - 300}px
              );
            }
            50% {
              transform: translate(
                #{random(600) - 300}px,
                #{random(600) - 300}px
              );
            }
            75% {
              transform: translate(
                #{random(600) - 300}px,
                #{random(600) - 300}px
              );
            }
          }
        }
      }
    }
  }

  // 添加网格效果
  .grid {
    position: absolute;
    width: 100%;
    height: 100%;

    .h-line,
    .v-line {
      position: absolute;
      background: rgba(0, 183, 255, 0.1);

      &::after {
        content: "";
        position: absolute;
        background: inherit;
        filter: blur(2px);
      }
    }

    .h-line {
      width: 100%;
      height: 1px;

      @for $i from 1 through 20 {
        &:nth-child(#{$i}) {
          top: #{$i * 5}vh;
          animation: glowH 4s ease-in-out infinite;
          animation-delay: #{$i * 0.1}s;
        }
      }
    }

    .v-line {
      width: 1px;
      height: 100%;

      @for $i from 1 through 20 {
        &:nth-child(#{$i + 20}) {
          left: #{$i * 5}vw;
          animation: glowV 4s ease-in-out infinite;
          animation-delay: #{$i * 0.1}s;
        }
      }
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

@keyframes glowH {
  0%,
  100% {
    opacity: 0.1;
    box-shadow: 0 0 4px rgba(0, 183, 255, 0.1);
  }
  50% {
    opacity: 0.3;
    box-shadow: 0 0 8px rgba(0, 183, 255, 0.3);
  }
}

@keyframes glowV {
  0%,
  100% {
    opacity: 0.1;
    box-shadow: 0 0 4px rgba(0, 183, 255, 0.1);
  }
  50% {
    opacity: 0.3;
    box-shadow: 0 0 8px rgba(0, 183, 255, 0.3);
  }
}

// 数字动画
:deep(.dv-digital-flop) {
  .number {
    font-size: 24px !important;
    color: #00e4ff !important;
  }
}

// 添加图表动画
:deep(.dv-charts) {
  .bar-item {
    transition: all 0.3s;

    &:hover {
      transform: translateX(5px);
      filter: brightness(1.2);
    }
  }

  .label-line {
    fill: #fff;
    font-size: 14px;
  }

  .grid-line {
    stroke: rgba(255, 255, 255, 0.1);
  }
}

// 胶囊图样式优化
:deep(.dv-capsule-chart) {
  .label-column {
    color: #fff !important;
    font-size: 18px !important;
  }

  .unit {
    fill: #fff !important;
    font-size: 16px !important;
  }

  .value-text {
    font-size: 18px !important;
  }

  .capsule-container {
    &:hover {
      .capsule-item {
        filter: brightness(1.2);
      }
    }
  }

  .capsule-chart {
    padding: 20px 0;
  }
}

.order-panel {
  width: 100%;
  height: max-content;
  padding: 0 20px;

  .order-header {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 228, 255, 0.2);

    .title {
      font-size: 30px;
      color: #00e4ff;

      .number {
        font-size: 32px;
        margin-left: 10px;
      }
    }

    .icon-today {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #4d98ff;
      font-size: 28px;
    }
  }

  .order-content {
    display: flex;
    height: calc(100% - 60px);
    padding: 10px 0;

    .hall-food,
    .takeout {
      flex: 1;
      display: flex;
      flex-direction: column;

      .type-icon {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #4f9db7;
        font-size: 20px;
        margin-bottom: 15px;

        i {
          font-size: 24px;
        }
      }

      .meals {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        .meal-item {
          text-align: center;

          .count {
            font-size: 24px;
            color: #00e4ff;
            margin-bottom: 5px;
          }

          .label {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }

    .hall-food .meals {
      justify-content: space-around;
    }

    .takeout .meals {
      justify-content: space-around;
    }
  }
}

.frequency-panel {
  width: 100%;
  height: 280px;
  padding: 20px;

  .chart-header {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .help-icon {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
      cursor: pointer;
      transition: color 0.3s;
      
      &:hover {
        color: #00e4ff;
      }
    }
  }

  .panel-content {
    height: calc(100% - 40px);
    display: flex;
    gap: 20px;
  }

  .chart-section {
    width: 66%;
    height: 100%;

    .frequency-chart {
      height: 100%;
      width: 100%;
    }
  }

  .subsidy-info {
    width: 34%; // 占据三分之一宽度
    background: rgba(0, 228, 255, 0.1); // 主题色背景
    border-radius: 8px; // 增加圆角
    border: 1px solid rgba(0, 228, 255, 0.3); // 边框颜色
    padding: 15px; // 增加内边距
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0 4px 15px rgba(0, 228, 255, 0.2); // 增加阴影效果

    .subsidy-header {
      font-size: 20px; // 增大标题字体
      color: #00e4ff; // 主题色
      margin-bottom: 15px; // 增加底部间距
      text-align: center;
      font-weight: bold; // 加粗
    }

    .subsidy-details {
      display: flex;
      flex-direction: column;
      gap: 10px; // 增加间距

      .subsidy-item {
        display: flex;
        justify-content: space-between;
        font-size: 18px; // 增大字体
        color: rgba(255, 255, 255, 0.9); // 更亮的字体颜色
        padding: 5px 10px; // 增加内边距
        border-radius: 4px; // 圆角
        background: rgba(0, 228, 255, 0.2); // 背景色
        transition: background 0.3s; // 背景色过渡效果

        &:hover {
          background: rgba(0, 228, 255, 0.3); // 悬停时的背景色
        }
      }
    }
  }
}

.trace-panel {
  width: 100%;
  height: 325px;
  padding: 20px;
  padding-bottom: 60px;

  :deep(.dv-scroll-board) {
    .header {
      font-size: 16px;
      color: #00e4ff;
      font-weight: bold;
      text-align: center;
    }

    .rows {
      .row-item {
        font-size: 14px;
        transition: all 0.3s;
        text-align: center;

        &:hover {
          background: rgba(0, 228, 255, 0.1) !important;
        }

        .cell {
          &:nth-child(1) {
            color: #00e4ff;
          }
          &:nth-child(2) {
            color: #75f95d;
          }
          &:nth-child(3) {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }
}

.health-cert-panel {
  width: 100%;
  height: 360px;
  margin-right: 20px;
  padding: 20px;
  position: relative;

  .cert-carousel {
    width: 100%;
    height: 76%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;

    .cert-item {
      position: absolute;
      width: 320px;
      height: 220px;
      left: 50%;
      top: 50%;
      transition: all 0.5s ease;
      transform-origin: center center;

      &:hover {
        transform: translate(-50%, -50%) scale(1.05) !important;
        z-index: 10 !important;
        opacity: 1 !important;
      }

      .cert-image {
        width: 100%;
        height: 220px;
        position: relative;
        overflow: hidden;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        background: #fff;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 5px;
        }
      }
    }
  }
}

.trace-panel {
  width: 100%;
  height: 325px;
  padding: 20px;
  padding-bottom: 60px;
}

.delivery-height {
  height: 530px !important;
  padding-bottom: 20px !important;

  .trace-board {
    height: calc(100% - 60px) !important;
  }
}

.health-panel {
  width: 100%;
  height: 280px;
  padding: 20px;

  .health-chart {
    height: calc(100% - 40px);
    margin-top: 10px;
  }
}

.empty-state {
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 228, 255, 0.05);
  border-radius: 4px;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    color: #00e4ff;
    text-shadow: 0 0 10px rgba(0, 228, 255, 0.3);
  }

  .empty-text {
    font-size: 16px;
    color: #00e4ff;
    letter-spacing: 1px;
    text-shadow: 0 0 10px rgba(0, 228, 255, 0.3);

    &::before,
    &::after {
      content: "";
      display: inline-block;
      width: 20px;
      height: 1px;
      background: #00e4ff;
      margin: 0 10px;
      vertical-align: middle;
      opacity: 0.6;
    }
  }
}
</style>

<!-- 全局弹窗样式 -->
<style lang="scss">
.frequency-tooltip {
  .tooltip-content {
    .tooltip-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      min-width: 200px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .label {
        color: #00e4ff;
        font-weight: bold;
      }
      
      .desc {
        color: #fff;
      }
    }
  }
}
</style> 